import { Component, OnInit, Input, EventEmitter, Output, ViewChild, TemplateRef } from '@angular/core';

import {MatDialog} from '@angular/material/dialog';

import { TypedefdialogComponent } from '../typedefdialog/typedefdialog.component';

import { VehiculeparamComponent } from '../vehiculeparam/vehiculeparam.component';

import { PredefparamchooseComponent } from '../predefparamchoose/predefparamchoose.component';

import { RecurrentComponent } from '../recurrent/recurrent.component';

import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

import { ServicepoolService } from '../services/servicepool.service';

import { MatOption } from '@angular/material/core'; 

import { MatSelect } from '@angular/material/select' ;


@Component({
  selector: 'app-packagepublic',
  templateUrl: './packagepublic.component.html',
  styleUrls: ['./packagepublic.component.css']
})
export class PackagepublicComponent implements OnInit {

  Tabval = "" ;

  newParam = ""  ;

  theChoosenDataType = "" ;

  @Input() pack : any ;

  garantie : any ;

  descriptionpack : any ;

  @Output() DeletionOrderToReturnBackEvent = new EventEmitter<string>();

  checkStatus = [] ;

  checkboxEditDeactivate = [] ;

  eltsType = [] ;

  choosenGarantieIndex : any ;

  saveBtnState = "done_all" ;

  primenameedit = "edit" ;

  baseElement = "" ;

  editprimename = 0 ;

  configPrimeBtn = false ;

  primeconfigObject : any ;

  retourClientWS : any ;

  headClass = "card-header card-header-tabs card-header-primary" ;

  rowNumber = 0 ;
  resultArray = [] ;
  subTabLength = 2 ;


  allGaranties = [] ;

  theClickedPrimeParams : any ;

  actuallyconfPrimIndex : any ;


  askedPredefCustParamsValues = [] ;
  askedPredefCustParams = [] ;
  paramsNames = [] ;
  params = [] ;


  incomingvalPredefParams = [] ;

  encours = 1 ;

  checkedParams : any ;
  
  @Input() configuration : any[] ;

  @Input() assurancetype : any ;

  @Input() compagnie : any ;

  @Input() choosenBigCateg: any ;


  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;
  spinnerDialogRef : any ;

  @ViewChild('packagedescript') packagedescriptDialog: TemplateRef<any>;
  packagedescriptDialogRef : any ;

  @ViewChild('packagepredefvalues') packagepredefvaluesDialog: TemplateRef<any>;
  packagepredefvaluesDialogRef : any ;


  @ViewChild('matRef') matRef: MatSelect;

  clearGarantieSelect() {
    this.matRef.options.forEach((data: MatOption) => data.deselect());
  }

  constructor(public dialog: MatDialog,  private configServer: ServicepoolService) {
  }

  ngOnInit(): void {

    console.log(this.pack) ;

  	var onChunkArray = [] ;
  	var index = 0 ;
  	this.resultArray = this.pack.composition.reduce((indexDead, item ) => { 
  	const chunkIndex = Math.floor(index/this.subTabLength)

  	if(!onChunkArray[chunkIndex]) {
  	  onChunkArray[chunkIndex] = [] // start a new chunk
  	}

  	onChunkArray[chunkIndex].push(item) ;

  	index++ ;

  	return onChunkArray ;
  	}, []) ;

    this.checkedParams =  this.pack.composition;

    for (var i = 0; i< this.pack.composition.length; i++) {
      this.checkStatus.push(true) ;
      this.eltsType.push([]) ;
    }

    this.descriptionpack = this.pack.description ;

    this.getAllPossibleGaranties() ;

  }



  initialize(){
    this.checkStatus = [] ;
    this.checkboxEditDeactivate = [] ;
    this.checkedParams = [] ;

    var onChunkArray = [] ;
    var index = 0 ;
    this.resultArray = this.pack.composition.reduce((indexDead, item ) => { 
    const chunkIndex = Math.floor(index/this.subTabLength)

    if(!onChunkArray[chunkIndex]) {
    onChunkArray[chunkIndex] = [] ; // start a new chunk
    }

    onChunkArray[chunkIndex].push(item) ;

    index++ ;

    return onChunkArray ;
    }, []) ;

    this.checkedParams =  this.pack.composition;

    for (var i = 0; i< this.pack.composition.length; i++) {
      this.checkStatus.push(true) ;
      this.eltsType.push([]) ;
    }
  }


  setPredefParamValues(index){
    if(this.pack.valeurspredefdupack[index].params.length!=0){
      this.actuallyconfPrimIndex = index ; 
      this.theClickedPrimeParams = this.pack.valeurspredefdupack[index] ; 
      this.incomingvalPredefParams = this.pack.valeurspredefdupack[index].valpredefparams ;
      this.configEnsForcateg() ;      
    }

    console.log("============") ;
    console.log(this.pack.valeurspredefdupack[index]) ;
  }


  configEnsForcateg(){
    this.params = [] ;
    this.paramsNames = [] ;
    this.askedPredefCustParams = [] ;
    this.askedPredefCustParamsValues = [] ;
    this.encours = 1 ;
    this.openpackagepredefvaluesDialog() ;
    this.goOneForThis() ;
  }


  choosedInSelectParamChange(event, slctd){
    let choosedVal = event.value ;
    console.log("there with "+slctd+" "+choosedVal) ;
    this.askedPredefCustParamsValues[slctd] = choosedVal ;
  }



  getAlreadySetValPredefIfExist(indexEntrant){
    console.log() ;
    console.log(this.askedPredefCustParams) ;
    for (var i = 0; i < this.incomingvalPredefParams.length; i++) {
      if(this.incomingvalPredefParams[i].nomFrmt==this.askedPredefCustParams[indexEntrant].nomFrmt)
        return this.incomingvalPredefParams[i].valeur ;
    }
    return "" ;
  }


  savePredefValues(){
    let valpredefparams = [] ;

    for (var i = 0; i < this.askedPredefCustParams.length; i++) {
      let lignePredefValParam = {"nomFrmt":this.askedPredefCustParams[i].nomFrmt, "valeur": this.askedPredefCustParamsValues[i]} ;
      valpredefparams.push(lignePredefValParam) ;
    }

    this.theClickedPrimeParams.valpredefparams = valpredefparams ;

    this.pack.valeurspredefdupack[this.actuallyconfPrimIndex] = this.theClickedPrimeParams ;

    this.closepackagepredefvaluesDialog() ;

    console.log(this.pack.valeurspredefdupack) ;
  }


  isalreadyIn(tabBi, data){
    for (var i = tabBi.length - 1; i >= 0; i--) {
      if (tabBi[i].nomFrmt==data.nomFrmt )
        return true;
    }
    return false ;
  }


  goOneForThis(){
    let potentialParams = this.theClickedPrimeParams.params ;
    for (var i = 0 ; i < potentialParams.length; i++) {
      if(potentialParams[i].type=="custompredef" && potentialParams[i].intitule!="PERIODICITE"){
        if(!this.isalreadyIn(this.params, potentialParams[i]) ){
          this.params.push(potentialParams[i]) ;
        }                    
        if ( !this.paramsNames.includes(potentialParams[i].nomFrmt)){
          this.paramsNames.push(potentialParams[i].nomFrmt) ;
          this.askedPredefCustParams.push(potentialParams[i]) ;
          this.askedPredefCustParamsValues.push("") ;
        }
      }
      if(potentialParams[i].type=="recurrent"){
        let allRemoteParams = this.configServer.getAllParamRecurrent(1, potentialParams[i].nomFrmt).then( (retourbi) => {
          this.retourClientWS = retourbi ;
          var statutrec = this.retourClientWS.statutreq ;
          if(statutrec==1){
            let data = this.retourClientWS.data ;  
            for (var i = 0 ; i <data.length; i++) {
              if(!this.isalreadyIn(this.params, data[i]) ){
                this.params.push(data[i]) ;
              }
              if(data[i].type=="custompredef" && data[i].intitule!="PERIODICITE"){
                if (!this.paramsNames.includes(data[i].nomFrmt)){
                  this.paramsNames.push(data[i].nomFrmt) ;
                  this.askedPredefCustParams.push(data[i]) ;
                  this.askedPredefCustParamsValues.push("") ;
                }
              }
            }
          }
          else
            console.log("Failed") ;
        }) ;
      }    
    }
    this.encours = 0 ;
  }



  getPreselectedValue(index){
   // let current = this.getIndexCurrentPredefParam(askedPredefCustParams[index]) ;

  }

  getAllPossibleGaranties(){
    console.log("Here we go 187 !!! ") ;
    this.configServer.getAllPossibleGaranties("thiswii", this.assurancetype.raniee, this.choosenBigCateg.idcateg).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        this.allGaranties = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  choosedInSelectGarantietoAdd(slctd){

      let uneLigne = {"garantie":this.allGaranties[slctd].nom, 
                        "params": JSON.parse(this.allGaranties[slctd].params),
                        "valpredefparams":[] } ;

      this.pack.valeurspredefdupack.push(uneLigne) ;

      this.pack.composition.push( this.allGaranties[slctd].nom ) ;

      this.checkStatus.push(true) ;

      var onChunkArray = [] ;

      var index = 0 ;

      this.resultArray = this.pack.composition.reduce((indexDead, item ) => { 
      const chunkIndex = Math.floor(index/this.subTabLength) ;

      if(!onChunkArray[chunkIndex]) {
        onChunkArray[chunkIndex] = [] ; 
      }

      onChunkArray[chunkIndex].push(item) ;

      index++ ;

      return onChunkArray ;
      }, []) ; 

      this.clearGarantieSelect() ;
  }


  getAllPossibleParamsForThisGarantie(){

    this.openSpinnerDialog();
    console.log("Here we go 187 !!! ") ;
    this.configServer.getAllPossibleParamsForThisGarantie("thiswii", this.garantie.intitule).then( (retourbi) => {    
    this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        //this.allBigCategories = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  soppiMbirrMi(domaine){

	  this.Tabval = (this.Tabval==this.pack.nompack)? "-":this.pack.nompack ;
  }

  jsonElementFactory(baseElmt, newProp, intitule, type){
  	if (baseElmt=="")
  		return '{"primeName": "'+this.garantie.params.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "")+'", "primeNameLibelle": "'+this.garantie.intitule+'", "params": [{'+'"name" : "'+newProp+'", "intitule": "'+intitule+'", "type": '+type+' }]}' ;  
  	else
  		return baseElmt.substring(0, baseElmt.length-2)+', {"name" : "'+newProp+'", "intitule": "'+intitule+'", "type": '+type+' }]}' ;
  }

  jsonElementFactoryFinale(baseElmt, formulation){

      return baseElmt.substring(0, baseElmt.length-1)+', "formulation" : '+formulation+'}' ;
  }

  openDialog(nomParam, typeIndex) {
    const dialogRef = this.dialog.open(TypedefdialogComponent, {
      data: {
        ParamsName: {"nomFrmt": this.formatThisString(nomParam), "intitule": nomParam, "type":"simple"} ,
        typechoice: ["***"]
      },
       disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result) ;
      this.eltsType[typeIndex] = result ;
    });
  }

  openDialogVehicParam() {
    const dialogRef1 = this.dialog.open(VehiculeparamComponent, {
      data: {
        ParamsName : [
            {"nomFrmt": this.formatThisString("Puissance"), "intitule": "Puissance", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Energie"), "intitule": "Energie", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Nombre de Place"), "intitule": "Nombre de Place", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Poids Total en Charge Autorisé (PTAC)"), "intitule": "Poids Total en Charge Autorisé (PTAC)", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Poids Vide"), "intitule": "Poids Vide", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Charge Utile"), "intitule": "Charge Utile", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Poids Total Roulant (PTR)"), "intitule": "Poids Total Roulant (PTR)", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Cylindre"), "intitule": "Cylindre", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Date mise en circulation"), "intitule": "Date mise en circulation", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Genre"), "intitule": "Genre", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Carosserie"), "intitule": "Carosserie", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Date Mise en Circulation"), "intitule": "Date Mise en Circulation", "type":"predefvehiv"}
        ]
      },

       disableClose: true
    });

    dialogRef1.afterClosed().subscribe(result => {
      console.log("Result For Vehicule Config") ;      
      var choosenVehicParams = JSON.parse(result) ;      

      for (var i = 0; i<choosenVehicParams.choosenParams.length; i++) {
        this.garantie.params.push(choosenVehicParams.choosenParams[i]) ;
        this.eltsType.push(choosenVehicParams.typos[i]) ;

        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        var onChunkArray = [] ;
        var index = 0 ;
        this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
          const chunkIndex = Math.floor(index/this.subTabLength) ;

          if(!onChunkArray[chunkIndex]) {
            onChunkArray[chunkIndex] = [] ; 
          }
          onChunkArray[chunkIndex].push(item) ;
          index++ ;
          return onChunkArray ;
        }, []) ; 
      }
    });
  }


  openDialogRecurrParam() {
    const dialogRef1 = this.dialog.open(RecurrentComponent, {
      data: {
        ParamsName : [
        ]
      },

       disableClose: true
    });

    dialogRef1.afterClosed().subscribe(result => {
      console.log("Result For Vehicule Config") ;      
      var choosenVehicParams = JSON.parse(result) ;      

      for (var i = 0; i<choosenVehicParams.choosenParams.length; i++) {
        this.garantie.params.push(choosenVehicParams.choosenParams[i]) ;
        this.eltsType.push(choosenVehicParams.typos[i]) ;

        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        var onChunkArray = [] ;
        var index = 0 ;
        this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
          const chunkIndex = Math.floor(index/this.subTabLength) ;

          if(!onChunkArray[chunkIndex]) {
            onChunkArray[chunkIndex] = [] ; 
          }
          onChunkArray[chunkIndex].push(item) ;
          index++ ;
          return onChunkArray ;
        }, []) ; 
      }
    });
  }



  openDialogPredefCustomParam() {
    const dialogRef1 = this.dialog.open(PredefparamchooseComponent, {
      data: {},
       disableClose: true
    });

    dialogRef1.afterClosed().subscribe(result => {
      console.log("Result For Vehicule Config") ;      
      var choosenVehicParams = JSON.parse(result) ;      

      for (var i = 0; i<choosenVehicParams.choosenParams.length; i++) {
        this.garantie.params.push(choosenVehicParams.choosenParams[i]) ;
        this.eltsType.push(choosenVehicParams.typos[i]) ;

        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        var onChunkArray = [] ;
        var index = 0 ;
        this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
          const chunkIndex = Math.floor(index/this.subTabLength) ;

          if(!onChunkArray[chunkIndex]) {
            onChunkArray[chunkIndex] = [] ; 
          }
          onChunkArray[chunkIndex].push(item) ;
          index++ ;
          return onChunkArray ;
        }, []) ; 
      }
    });
  }


  onPrimeChoose(event, i, j) {
  	if (event.target.checked){
  		this.checkStatus[j+2*i]=true ;
      var typeIndex = j+2*i ;
  	}
  	else{
    		this.checkStatus[j+2*i]=false ;	  	
  	}
  	console.log(this.baseElement);	
  }


  ajouterParam(){

  	if (this.newParam != "" && this.theChoosenDataType!=""  && this.saveBtnState=="done_all"){
    	this.garantie.params.push( {"nomFrmt": this.formatThisString(this.newParam), "intitule": this.newParam, "type":"simple", "datatype": this.theChoosenDataType}) ;

  	  this.checkStatus.push(false) ;
  		this.checkboxEditDeactivate.push(false) ;

  		var onChunkArray = [] ;

  		var index = 0 ;

  		this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
  		const chunkIndex = Math.floor(index/this.subTabLength) ;

  		if(!onChunkArray[chunkIndex]) {
    		onChunkArray[chunkIndex] = [] ; 
  		}

  		onChunkArray[chunkIndex].push(item) ;

  		index++ ;

  		return onChunkArray ;
  		}, []) ; 

      this.theChoosenDataType = "" ;
  		this.newParam = "" ;
  	}
  }



  savePack(){

  	if (this.saveBtnState=="done_all"){
       this.openSpinnerDialog() ;

  		for (var i = 0; i< this.checkboxEditDeactivate.length; i++) {
  			this.checkboxEditDeactivate[i] = true ;
  		}

      var allParamsConfigs = [] ;
  		for (var i = 0; i< this.checkStatus.length; i++) {
  			if(this.checkStatus[i] == false){
  				this.pack.composition.splice(i, 1) ;
          this.pack.valeurspredefdupack.splice(i, 1) ;
			  }
		  }

    this.configServer.updatePackPublic("thiswii", this.pack).then( (retourbi) => {

      this.closeSpinnerDialog()
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        console.log("Done") ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;    

      //this.initialize() ;

	  	//this.saveBtnState = "edit" ; 
      //this.configPrimeBtn = true ;

  	}else{

      this.headClass = "card-header card-header-tabs card-header-primary" ;
      this.saveBtnState = "done_all" ;
      this.configPrimeBtn = false ;  		
    }

  }



  updatePackDescript(){

    if(this.descriptionpack!=undefined){
      this.configServer.uppatePackDescript(this.pack.idpack, this.descriptionpack).then( (retourbi) => {
        this.closepackagedescriptDialog() ;
          this.retourClientWS = retourbi ;
          var statutrec = this.retourClientWS.statutreq ;
          if(statutrec==1){
            this.pack.description = this.descriptionpack ;
          }
          else
            console.log("Failed") ;
      }) ; 
    }   
  }





  configPrime(){

    var choosenParams =[] ;
    console.log(this.garantie.params) ;

    choosenParams =  this.copyThisArray(this.garantie.params) ;

    for (var i = 0; i< choosenParams.length; i++) {
      if(choosenParams[i].nomFrmt=="Energie"){
        choosenParams.push({"nomFrmt": this.formatThisString("Essence"), "intitule": "Essence", "type":"predefvehiv"}  ) ; 
        choosenParams.push({"nomFrmt": this.formatThisString("Diesel"), "intitule": "Diesel", "type":"predefvehiv"}  ) ;
        choosenParams.push({"nomFrmt": this.formatThisString("Hybride"), "intitule": "Hybride", "type":"predefvehiv"}  ) ;
        choosenParams.push({"nomFrmt": this.formatThisString("Electrique"), "intitule": "Electrique", "type":"predefvehiv"}  ) ;
      }
      if(choosenParams[i].type=="custompredef"){
        console.log("THERERERER") ;
        console.log(choosenParams[i]) ;
        for (var k = 0; k< choosenParams[i].values.length; k++) {
          choosenParams.push({"nomFrmt": choosenParams[i].values[k], "intitule":choosenParams[i].values[k], "type":"custompredefval"}  ) ; 
        }
      }
    }

    this.openDialogForPrimeConfig(this.garantie.intitule, 1, choosenParams, this.garantie.formule) ;
  }


  copyThisArray(arrayToCopy){
    var copyArray = [] ;
    for (var i = 0; i< arrayToCopy.length; i++) {
      copyArray.push(arrayToCopy[i]) ;
    }
    return copyArray ;
  }

  openDialogForPrimeConfig(nomPrime, typeIndex, params, laFormule) {

    var predefinedVariables = params ;

    const dialogRef = this.dialog.open(TypedefdialogComponent, {
      data: {
        ParamsName: nomPrime,
        typechoice: predefinedVariables,
        formule: laFormule
      },
       disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result) ;

      this.garantie.formule = JSON.parse(result) ;

      this.headClass = "card-header card-header-tabs card-header-danger" ;

      var toReturn = {"ordre":"saveconfig", "garantie": this.garantie }; 

      this.DeletionOrderToReturnBackEvent.emit(JSON.stringify(toReturn)) ;

    });
  }

  editPrime(){
    if(this.editprimename==0){
      this.editprimename = 1 ;
      this.primenameedit = "done";      
    }else{

      var toReturn = {"ordre":"rename", "garantie": this.garantie }; 

      this.DeletionOrderToReturnBackEvent.emit(JSON.stringify(toReturn)) ;
      this.editprimename = 0 ;
      this.primenameedit = "edit";            
    }
  }

  deletePrime(){

    var data = {"title": "Suppression Garantie", "message": "Voulez-vous vraiment supprimer cette Garantie ?"} ;
    const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {data});
    
    dialogRef1.afterClosed().subscribe(result => {
      console.log(result) ;
      if(result=="dlt"){
          var toReturn = {"ordre":"fermer", "garantie": this.garantie  }; 
          this.DeletionOrderToReturnBackEvent.emit(JSON.stringify(toReturn)) ;
      }
      else{
        console.log("") ;        
      }

    });
  }

  makeVisible(){
    this.pack.usable = 1;
  }

  removeVisibility(){
    this.pack.usable = 0;
  }

  formatThisString(name){
    return name.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ;
  }

 
  openpackagepredefvaluesDialog() {
    this.packagepredefvaluesDialogRef = this.dialog.open(this.packagepredefvaluesDialog);
  }

  closepackagepredefvaluesDialog() {
    this.packagepredefvaluesDialogRef.close();
  }


  openpackagedescriptDialog() {
    this.packagedescriptDialogRef = this.dialog.open(this.packagedescriptDialog);
  }

  closepackagedescriptDialog() {
    this.packagedescriptDialogRef.close();
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }



}
